import { DIR_DOCUMENT_FACTORY } from '@angular/cdk/bidi/typings/dir-document-token';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Field } from '../../models/field';
import { FieldConfig } from '../../models/field-config';

@Component({
  selector: 'app-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss']
})
export class FormSelectComponent implements Field{
  @ViewChild('dd', {static: true} ) input: ElementRef<HTMLInputElement>;
  config: FieldConfig;
  group: FormGroup;
  selectedOther: boolean = false;
  selectValue: string = "";
   otherValue: string = null;

  onDDChange(value: string){

    this.selectValue = value;
    if(value == 'Andet')
    {
      this.config.value = this.otherValue;
      this.group.controls[this.config.name].setValue(this.selectValue, {emitEvent: true});
      this.selectedOther = true;
    }
    else{
      this.group.controls[this.config.name].setValue(value , {emitEvent: true});
      this.otherValue = null;
      this.selectedOther = false;
    }
  }
  onInputBlur(event: any){
    this.group.controls[this.config.name].setValue(event.target.value , {emitEvent: true});
  }
}
